import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  & > form {
    width: 100%;
    margin: 0 auto;
    max-width: 300px;
  }
  & > form > * {
    margin-bottom: 20px;
    width: 100%;
  }
`;

export const Header = styled.div`
  border-bottom: 1px solid #ccc;
  padding: 10px;
  text-align: center;
  margin-bottom: 30px;
`;
